module.exports = __webpack_public_path__ + "static/media/anonymousSmall.504c6eba.svg";